module.exports = __webpack_public_path__ + "static/media/wateruser-tribes.4296f9e0.png";